/* global attachEvent */

// Languge backarrow for mobile
const floorTableRow = document.querySelectorAll('[data-floor-id]');

const toggleHideClass = (el, add) => {
  el.classList.toggle('hide', add);
};

attachEvent('[data-floor]', 'click', (ev) => {
  const targetFloor = ev.target.closest('[data-floor]').getAttribute('data-floor');

  floorTableRow.forEach((el) => {
    const foorId = el.getAttribute('data-floor-id');
    toggleHideClass(el, foorId !== targetFloor);
  });
});

document.addEventListener('click', (evt) => {
  const imageContainer = document.querySelector('.floor-dimensions__image');
  const tableContainer = document.querySelector('.floor-dimensions__table');
  let targetElement = evt.target; // clicked element

  do {
    if (targetElement === tableContainer || targetElement === imageContainer) {
      return;
    }
    targetElement = targetElement.parentNode;
  } while (targetElement);

  floorTableRow.forEach((el) => {
    toggleHideClass(el, false);
  });
});
